import { Component, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-epin-info',
  templateUrl: './epin-info.component.html',
  styleUrls: ['./epin-info.component.scss'],
})
export class EpinInfoComponent {
  @Input() epinAmount: number;
  @Input() tokenSymbol: string;

  constructor(
    public modalController: ModalController,
    public alertController: AlertController,
    public translate: TranslateService
  ) { }

  onSubmit() {
    this.modalController.dismiss(true);
  }

  onCancel() {
    this.modalController.dismiss(false);
  }

}
